/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';

import { Loader } from '@googlemaps/js-api-loader';

import * as S from './styles';
import { googleLoader } from '../../utils/googleLoader';

interface DeliveryAddressModalProps {
  lat: number;
  lon: number;
  useCurrentLocation: () => void;
  setLatLng: React.Dispatch<
    React.SetStateAction<{
      lat: number | undefined;
      lng: number | undefined;
    } | null>
  >;
}

const GoogleMap: React.FC<DeliveryAddressModalProps> = ({
  lat,
  lon,
  useCurrentLocation,
  setLatLng,
}) => {
  let map: google.maps.Map;
  let marker: google.maps.Marker;
  let infoWindow: google.maps.InfoWindow;

  const handleLocationError = (
    browserHasGeolocation: boolean,
    _infoWindow: google.maps.InfoWindow,
    pos: google.maps.LatLng,
  ): void => {
    _infoWindow.setPosition(pos);
    _infoWindow.setContent(
      browserHasGeolocation
        ? 'Erro: Ative a localização do dispositivo para usar esta função.'
        : 'Erro: Seu navegador não dá suporte a geolocalização.',
    );
    _infoWindow.open(map);
  };

  useEffect(() => {
    googleLoader.load().then(() => {
      const myLatlng = new google.maps.LatLng(lat, lon);

      map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
        center: myLatlng,
        zoom: 18,
      });

      marker = new google.maps.Marker({
        position: myLatlng,
        map,
        draggable: true,
        title: 'Localização',
      });

      infoWindow = new google.maps.InfoWindow();

      const locationButton = document.createElement('button');
      locationButton.textContent = 'Usar localização atual';
      locationButton.type = 'button';
      locationButton.classList.add('localization');
      locationButton.addEventListener('click', useCurrentLocation);

      map.controls[google.maps.ControlPosition.TOP_LEFT].push(locationButton);

      marker.addListener('dragend', () => {
        setLatLng({
          lat: marker.getPosition()?.lat(),
          lng: marker.getPosition()?.lng(),
        });
      });

      locationButton.addEventListener('click', () => {
        // Try HTML5 geolocation.
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };

              setLatLng({
                lat: pos.lat,
                lng: pos.lng,
              });

              infoWindow.setPosition(pos);
              infoWindow.setContent('Localização encontrada.');
              infoWindow.open(map);
              map.setCenter(pos);
              marker.setPosition(pos);
            },
            () => {
              handleLocationError(true, infoWindow, map.getCenter()!);
            },
          );
        } else {
          // Browser doesn't support Geolocation
          handleLocationError(false, infoWindow, map.getCenter()!);
        }
      });
    });
  }, []);

  return <S.ContainerMap id="map" />;
};

export default GoogleMap;
